import React from "react";
import PicturesShell from "../PicturesShell";
import DesktopOnlyGraphic from "../DesktopOnlyGraphic";
import "./style.css";
import "../../styles/pictures-status-screens.css";

const DEVICE_REQUIREMENTS = [
  { id: "ios", label: "iOS 13+", detail: "iPhone & iPad" },
  { id: "android", label: "Android 9+", detail: "Phone & tablet" },
];

export default function DesktopOnlyScreen() {
  return (
    <PicturesShell mainClassName="pi-pictures-main--center pi-pictures-main--status pi-pictures-main--desktop">
      <div className="pi-pictures-status-card pi-pictures-status-card--premium pi-pictures-status-card--desktop">
        <span className="pi-pictures-label">Mobile only</span>
        <div className="pi-pictures-status-card__hero pi-pictures-status-card__hero--desktop">
          <DesktopOnlyGraphic />
        </div>
        <ul className="pi-device-requirements" aria-label="Supported devices">
          {DEVICE_REQUIREMENTS.map((item) => (
            <li key={item.id} className="pi-device-requirements__item">
              <span className="pi-device-requirements__label">{item.label}</span>
              <span className="pi-device-requirements__detail">{item.detail}</span>
            </li>
          ))}
        </ul>
        <h1>Use a mobile device for photos</h1>
        <p>
          This photo capture flow is designed for phones and tablets. Open your email link on a supported mobile device to continue.
        </p>
      </div>
    </PicturesShell>
  );
}
